'use client'

import React from 'react'
import { CartModal } from './CartModal'

export { type CartItem } from './types'

export function Cart() {
  return (
    <>
      <CartModal />
    </>
  )
}
